import '.e{display:grid;}.ssr-plugin'
import '.gp{grid-template-columns:repeat(2, minmax(250px, 1fr));}.ssr-plugin'
import '.gr{column-gap:1.5rem;}.ssr-plugin'
import '.iv{row-gap:1rem;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import useMediaQuery from '@app/util/useMediaQuery'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { styled } from 'inlines'
import { enrich } from '@i18n/localizeHelper'
import { RegionalListPlotModel } from 'functions/app/plot/list-regional'
import { useQuery } from '@based/sdk'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { navigate } from 'wouter/use-browser-location'
import { pages } from '@app/util/links'
import { GeoViewModel } from './models'
import { labelAddressBuilder } from '@app/util/helpers'
export const Locations = ({ entity }: { entity: GeoViewModel }) => {
  const isRegion = 'municipalities' in entity
  const locationListingContext = 'regionalLocation'
  const isMobile = useMediaQuery()
  const largerGap = isMobile ? '2rem' : '1.5rem'
  const [language, _] = useLanguage()
  const translations = i18n.languages[language].app

  const listPayload = isRegion
    ? { regionId: entity.id }
    : { municipalityId: entity.id }
  const plotQuery = useQuery('list-regional-plot', listPayload)
  const plots: RegionalListPlotModel[] = plotQuery.data ?? []

  const title = enrich(
    translations.regionPage.locationsIn ??
      `${translations.regionPage.locations} in {0} ({1})`,
    entity.name,
    plots.length,
  )
  return (
    <Column gap={largerGap} alignItems="stretch">
      <SectionHeader title={title} />
      <styled.div className="e gp gr iv"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {plots.map((plot) => {
          const imageSrc =
            typeof plot.media?.[0] === 'object' && plot.media?.[0]?.src
              ? plot.media[0].src
              : typeof plot.media?.[0] === 'string'
                ? plot.media[0]
                : undefined
          return (
            <InitiativeCard
              key={plot.slug}
              image={imageSrc ?? defaultProjectPicture}
              title={plot.name}
              description={plot.description}
              location={labelAddressBuilder(
                plot.location?.address,
                translations.common.notSpecified,
                locationListingContext,
              )}
              tagText={
                translations.common.plotApplicationStatus?.[
                  plot.applicationStatus
                ] ?? plot.applicationStatus
              }
              tagVariant={
                plot.applicationStatus === 'applicationOpen' ? 'green' : 'gray'
              }
              onClick={() => navigate(pages.plot(plot.slug))}
            />
          )
        })}
      </styled.div>
    </Column>
  )
}
